'use strict';

const escapeHtml = (str) => {
    if (typeof str !== 'string') return '';
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

const checkRoutes = (searchData, config) => {
    if (!config || !config.territorialRules || config.territorialRules.length === 0) {
        return null;
    }

    try {
        const departureObj = JSON.parse(searchData.departure);
        const destinationObj = JSON.parse(searchData.destination);
        const startDateObj = JSON.parse(searchData.startDate);

        const originCode = departureObj.code;
        const destCode = destinationObj.code;

        const departureDateStr = startDateObj.date || startDateObj;
        const departureDate = new Date(departureDateStr);
        departureDate.setHours(12, 0, 0, 0);

        const isRoundTrip = searchData.type === 'round';
        var returnDate = null;

        if (isRoundTrip && searchData.returnDate) {
            const returnDateObj = JSON.parse(searchData.returnDate);
            const returnDateStr = returnDateObj.date || returnDateObj;
            returnDate = new Date(returnDateStr);
            returnDate.setHours(12, 0, 0, 0);
        }

        const currentRoute = originCode + '-' + destCode;

        for (let i = 0; i < config.territorialRules.length; i++) {
            let rule = config.territorialRules[i];

            if (rule.routes.indexOf(currentRoute) !== -1) {
                let validFrom = new Date(rule.validity.departureDateFrom);
                let validTo = new Date(rule.validity.departureDateTo);

                validFrom.setHours(0, 0, 0, 0);
                validTo.setHours(23, 59, 59, 999);

                if (isRoundTrip) {
                    if (!returnDate) return null;
                    var returnInRange = returnDate >= validFrom && returnDate <= validTo;
                    if (returnInRange) return rule;
                } else {
                    var outboundInRange = departureDate >= validFrom && departureDate <= validTo;
                    if (outboundInRange) return rule;
                }
            }
        }
    } catch (e) {
        console.error(e);
    }

    return null;
};

const openModal = (matchedRule, searchData, continueCallback) => {
    var fullLocale = window.ITA_RefX_TerritorialLocale || 'it_IT';
    let lang = fullLocale.substring(0, 2).toLowerCase();
    
    if (!matchedRule.uiTitle[lang]) {
        lang = 'en'; 
    }

    var isLocaleDisabled = matchedRule.disabledLocales
        && matchedRule.disabledLocales.indexOf(fullLocale) !== -1;

    var icons = window.ITA_RefX_TerritorialIcons || {};
    var defaultIcon = icons['icon-adult'] || '';
    var iconMinus = icons.minus || '';
    var iconPlus = icons.plus || '';
    var maxPassengers = 9;

    let step2CategoriesHtml = '';
    matchedRule.passengerCategories.forEach((cat) => {
        let typesHtml = '';
        var isResidenti = (cat.uiId === 'residenti');

        cat.allowedPassengerTypes.forEach((type) => {
            var iconSrc = icons[type.iconId] || defaultIcon;
            var minValue = (isResidenti && type.typeId === 'adult') ? 1 : 0;
            var initialValue = minValue;

            let subtitleHtml = type.uiSecondaryLabel && type.uiSecondaryLabel[lang]
                ? `<span class="popup-travel-passengers-item__subtitle">${escapeHtml(type.uiSecondaryLabel[lang])}</span>`
                : '';

            typesHtml += `
                <div class="popup-travel-passengers-item territorial-pax-item" data-type-id="${escapeHtml(type.typeId)}" data-category-id="${escapeHtml(cat.uiId)}" data-min="${minValue}">
                    <div class="popup-travel-passengers-item__icon">
                        <img src="${escapeHtml(iconSrc)}" alt="${escapeHtml(type.uiPrimaryLabel[lang])}">
                    </div>
                    <div class="popup-travel-passengers-item__title-wrapper">
                        <span class="popup-travel-passengers-item__title">${escapeHtml(type.uiPrimaryLabel[lang])}</span>
                        ${subtitleHtml}
                    </div>
                    <div class="popup-travel-passengers-item__input">
                        <button type="button" class="minus-btn" disabled><img src="${escapeHtml(iconMinus)}"></button>
                        <input type="text" inputmode="numeric" pattern="\\d*" value="${initialValue}" data-min="${minValue}" readonly>
                        <button type="button" class="plus-btn"><img src="${escapeHtml(iconPlus)}"></button>
                    </div>
                </div>
            `;
        });

        let notesHtml = cat.uiLabelNotes && cat.uiLabelNotes[lang]
            ? `<div class="category-notes">${escapeHtml(cat.uiLabelNotes[lang])}</div>`
            : '';

        step2CategoriesHtml += `
            <div class="category-item">
                <label>
                    <input type="radio" name="territorial_category" value="${escapeHtml(cat.uiId)}">
                    ${escapeHtml(cat.uiLabel[lang])}
                </label>
                <div class="allowed-types-container" id="types-container-${escapeHtml(cat.uiId)}" style="display: none;">
                    <div class="territorial-pax-list">
                        ${typesHtml}
                    </div>
                    ${notesHtml}
                </div>
            </div>
        `;
    });

    var labels = window.ITA_RefX_TerritorialLabels || {};
    var lblStandard = escapeHtml(labels.btnStandard || 'Standard Fares');
    var lblDiscounted = escapeHtml(labels.btnDiscounted || 'Discounted Fares');
    var lblBack = escapeHtml(labels.btnBack || 'Back');
    var lblContinue = escapeHtml(labels.btnContinue || 'Continue');

    let modalHtml = `
        <div id="territorial-modal" class="ita-popup visible territorial-modal">
            <div class="territorial-modal__content">
                <div class="territorial-modal__header">
                    <button id="btn-territorial-close" class="territorial-modal__close" type="button" aria-label="Close">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1L13 13" stroke="#0B2340" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                </div>

                <div id="step-1-container" class="territorial-modal__step is-active">
                    <div class="territorial-modal__body">
                        <div id="territorial-content-asset" class="content-asset-placeholder" data-asset-id="${escapeHtml(matchedRule.uiContentAssetId)}">
                        </div>
                    </div>
                    <div class="territorial-modal__actions">
                        <button id="btn-step1-standard" class="territorial-modal__btn">
                            ${lblStandard}
                        </button>
                        ${!isLocaleDisabled ? `<button id="btn-step1-discount" class="territorial-modal__btn">
                            ${lblDiscounted}
                        </button>` : ''}
                    </div>
                </div>

                <div id="step-2-container" class="territorial-modal__step">
                    <div class="territorial-modal__body">
                        <h2 class="territorial-modal__step2-title">${escapeHtml(matchedRule.uiTitle[lang])}</h2>
                        <p class="territorial-modal__step2-warning">
                            ${escapeHtml(matchedRule.uiSecondaryTitle[lang])}
                        </p>
                        <div class="categories-list">
                            ${step2CategoriesHtml}
                        </div>
                    </div>
                    <div class="territorial-modal__actions">
                        <button id="btn-step2-back" class="territorial-modal__btn territorial-modal__btn--outline">
                            ${lblBack}
                        </button>
                        <button id="btn-step2-apply" class="territorial-modal__btn is-disabled" disabled>
                            ${lblContinue}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    `;

    $('body').append(modalHtml);

    if (matchedRule.uiContentAssetId) {
        var safeAssetId = matchedRule.uiContentAssetId.replace(/[^a-zA-Z0-9_-]/g, '');
        const $hiddenAsset = $('#asset-' + safeAssetId);
        if ($hiddenAsset.length) {
            $('#territorial-content-asset').html($hiddenAsset.html());
        }
    }

    $('#territorial-content-asset').on('click', '.j-accordion-header', function (e) {
        e.preventDefault();
        $(this).closest('.j-accordion').toggleClass('is-open');
    });

    const $modal = $('#territorial-modal');
    const $step1Container = $('#step-1-container');
    const $step2Container = $('#step-2-container');
    
    const $btnStep1Standard = $('#btn-step1-standard');
    const $btnStep1Discount = $('#btn-step1-discount');
    const $btnStep2Back = $('#btn-step2-back');
    const $btnStep2Apply = $('#btn-step2-apply');
    const $btnClose = $('#btn-territorial-close');
    
    const $radios = $('input[name="territorial_category"]');

    $btnClose.on('click', (e) => {
        e.preventDefault();
        $modal.remove();
    });

    $btnStep1Standard.on('click', (e) => {
        e.preventDefault();
        $modal.remove(); 
        continueCallback(searchData); 
    });

    $btnStep1Discount.on('click', (e) => {
        e.preventDefault();
        $step1Container.removeClass('is-active');
        $step2Container.addClass('is-active');
    });

    $btnStep2Back.on('click', (e) => {
        e.preventDefault();
        $step2Container.removeClass('is-active');
        $step1Container.addClass('is-active');
    });

    var updatePassengerButtons = function (categoryId) {
        var $container = $(`#types-container-${categoryId}`);

        if (categoryId === 'residenti') {
            var $adultInput = $container.find('[data-type-id="adult"] input');
            var $childInput = $container.find('[data-type-id="child"] input');
            var $infantInput = $container.find('[data-type-id="infant"] input');

            var adultCount = parseInt($adultInput.val()) || 0;
            var childCount = parseInt($childInput.val()) || 0;
            var infantCount = parseInt($infantInput.val()) || 0;
            var totalPax = adultCount + childCount;

            $adultInput.parent().find('.minus-btn').prop('disabled', adultCount <= Math.max(1, infantCount));
            $adultInput.parent().find('.plus-btn').prop('disabled', totalPax >= maxPassengers);

            $childInput.parent().find('.minus-btn').prop('disabled', childCount <= 0);
            $childInput.parent().find('.plus-btn').prop('disabled', totalPax >= maxPassengers);

            $infantInput.parent().find('.minus-btn').prop('disabled', infantCount <= 0);
            $infantInput.parent().find('.plus-btn').prop('disabled', infantCount >= adultCount);
        } else {
            var totalPax = 0;
            $container.find('.territorial-pax-item input').each(function () {
                totalPax += parseInt($(this).val()) || 0;
            });

            $container.find('.territorial-pax-item').each(function () {
                var $input = $(this).find('input');
                var val = parseInt($input.val()) || 0;
                var min = parseInt($input.data('min')) || 0;
                $(this).find('.minus-btn').prop('disabled', val <= min);
                $(this).find('.plus-btn').prop('disabled', totalPax >= maxPassengers);
            });
        }
    };

    var getTotalPassengers = function (categoryId) {
        var total = 0;
        $(`#types-container-${categoryId}`).find('.territorial-pax-item input').each(function () {
            total += parseInt($(this).val()) || 0;
        });
        return total;
    };

    var updateContinueButton = function () {
        var selectedId = $('input[name="territorial_category"]:checked').val();
        var isDisabled = !selectedId || getTotalPassengers(selectedId) < 1;
        $btnStep2Apply.prop('disabled', isDisabled);
        $btnStep2Apply.toggleClass('is-disabled', isDisabled);
    };

    var resetCategoryCounters = function (categoryId) {
        $(`#types-container-${categoryId}`).find('.territorial-pax-item').each(function () {
            var $input = $(this).find('input');
            var min = parseInt($input.data('min')) || 0;
            $input.val(min);
        });
        updatePassengerButtons(categoryId);
    };

    $radios.on('change', function () {
        var selectedValue = $(this).val();

        updateContinueButton();
        if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
        }

        $('.category-item').each(function () {
            var $item = $(this);
            var $radio = $item.find('input[name="territorial_category"]');
            var catId = $radio.val();

            if (catId === selectedValue) {
                $item.addClass('is-selected');
                $(`#types-container-${catId}`).slideDown(200, function () {
                    updatePassengerButtons(catId);
                    updateContinueButton();
                });
            } else {
                $item.removeClass('is-selected');
                $(`#types-container-${catId}`).slideUp(200);
                resetCategoryCounters(catId);
            }
        });
    });

    $modal.on('click', '.territorial-pax-item button', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $input = $btn.parent().find('input');
        var currentValue = parseInt($input.val()) || 0;
        var newValue = $btn.hasClass('minus-btn') ? currentValue - 1 : currentValue + 1;
        $input.val(newValue);

        var categoryId = $btn.closest('.territorial-pax-item').data('category-id');
        updatePassengerButtons(categoryId);
        updateContinueButton();
    });

    $btnStep2Apply.on('click', (e) => {
        e.preventDefault();
        const selectedCategoryId = $('input[name="territorial_category"]:checked').val();
        var $container = $(`#types-container-${selectedCategoryId}`);

        var passengers = {};
        $container.find('.territorial-pax-item').each(function () {
            var typeId = $(this).data('type-id');
            var count = parseInt($(this).find('input').val()) || 0;
            if (count > 0) {
                passengers[typeId] = count;
            }
        });

        searchData.isTerritorialFare = true;
        searchData.territorialRuleId = matchedRule.ruleId;
        searchData.territorialCategory = selectedCategoryId;
        searchData.territorialPassengers = JSON.stringify(passengers);

        $modal.remove();
        continueCallback(searchData);
    });
};

module.exports = {
    checkRoutes: checkRoutes,
    openModal: openModal
};